import styles from "./inputprimary.module.css";
import React from "react";
import PropTypes from "prop-types";

const InputPrimary = ({
  type = "text",
  placeholder = "Enter text",
  value = "",
  onChange = () => {},
  ...args
}) => {
  return (
    <input
      className={`col-12 ${styles.inputPrimary}`}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      {...args}
    />
  );
};

InputPrimary.propTypes = {
  type: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default InputPrimary;
